<template>
	<div id="product" class="service mainPage">
		<div id="banner">
			<div class="container">
				<div class="text">
					<h2>AI技术和业务专家团队匠心打造标准产出</h2>
				</div>
			</div>
			<img src="../assets/img/sb.jpg"/>
		</div>
		<div class="main">
			<div class="title">
				<h2>服务介绍</h2>
				<p>
					<span>SERVICE</span>
				</p>
			</div>
			<div class="container mainBox">
				<div class="row">
					<div class="col-md-6">
						<img src="../assets/img/sp1.png"/>
					</div>
					<div class="col-md-6">
						<div class="textL">
							<h4>数据交付</h4>
							<b>企业痛点：</b>
							<p>数据来源繁杂</p>
							<p>涉及多种类型的非结构化数据</p>
							<p>数据处理困难</p>
							<p>工作流繁杂</p>
							<p>人工成本高且易出错</p>
							<b>数据交付服务：</b>
							<p>提供结合OCR、自然语言处理、ETL等技术的标准化数据交付流水线</p>
							<p>将不同类型文件中的数据识别，提取出关键信息并转换为结构化数据</p>
							<p>自主研发数据质检工具、智能工作台，快速质检，工作流一目了然
							</p>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="textL">
							<h4>视频内容分析</h4>
							<b>企业痛点：</b>
							<p>处理视频耗时长、效率低、产出低</p>
								<p>需要标准化视频量大且视频内容多样化</p>
								<p>人工处理费用高</p>
								<p>处理视频需要高配置</p>
								<b>视频内容分析服务：</b>
								<p>自动化处理水印、片头片尾、广告</p>
								<p>提供结合机器视觉识别、OCR、自然语言处理等技术的智能视频流水线</p>
								<p>通过对视频内容分析，建立结构化知识模型，输出视频泛标签</p>
								<p>将音频数据转换为文本，对文本中的包含的信息进行分类和打标签等结构化处理，实现分段切割</p>
								<p>基于视频内容，智能构建知识图谱，深挖数据价值</p>
						</div>
					</div>
					<div class="col-md-6" style="text-align:right;">
						<img src="../assets/img/sp6.png"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<img src="../assets/img/sp3.png"/>
					</div>
					<div class="col-md-6">
						<div class="textL">
							<h4>数据治理</h4>
							<b>企业痛点：</b>
							<p>数据难统一</p>
								<p>公司数据系统陈旧</p>
								<p>数据缺乏标准</p>
								<p>数据难打通</p>
								<p>数据质量低</p>
								<b>数据治理服务：</b>
								<p>通过专业的业务人员对接帮助梳理数据情况，实现跨部门、跨系统的数据抽取、清洗、转换和整合服务，构建企业数据汇聚中心</p>
								<p>构建企业数据上下游链路关系，实现数据分析</p>
								<p>提供全方位的数据跟踪，比较，分析和综合，同时出具业务相关数据报表，使数据资产一目了然
							</p>
							<!-- <p><i class="iconfont icon-yuyin"></i><i class="iconfont icon-wenbenshibie"></i></p> -->
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="textR">
							<h4>数据采集</h4>
							<b>企业痛点：</b>
							<p>无法获得完全的网站数据</p>
								<p>已有数据单一</p>
								<p>已有数据杂乱</p>
							<b>数据采集服务：</b>
							<p>采用爬虫技术对信息进行爬取，一站式数据处理和服务</p>
							<p>可采集图片、文本、视频、音频等数据，并对数据进行去近似、去模糊等清洗</p>
							<p>对采集数据进行智能语义标注和打标签等处理
							</p>
							<!-- <p><i class="iconfont icon-nlp"></i><i class="iconfont icon-suanfaku"></i></p> -->
						</div>
					</div>
					<div class="col-md-6"style="text-align:right;">
						<img src="../assets/img/sp2.png"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="textR">
							<h4>数据安全</h4>
							<b>企业痛点：</b>
							<p>缺乏风险预知能力</p>
								<p>缺乏检测和响应能力</p>
								<p>网站易被其他流量攻击</p>
								<p>防火墙安全问题</p>
								<p>危险操作无预警</p>
								<b>数据安全服务：</b>
								<p>持续监控整个企业范围的结构化与非结构化数据访问，保护敏感数据</p>
								<p>根据公司情况定时实施漏洞扫描计划，检测数据存储漏洞，强化环境安全</p>
								<p>融合多种安全防护引擎和高级防护能力，提供全面安全防护</p>
								<p>实时防御行业竞争数据、高价值内容、隐私数据等被盗爬行为
							</p>
							<!-- <p><i class="iconfont icon-shujufenxi"></i><i class="iconfont icon-03"></i></p> -->
						</div>
					</div>
					<div class="col-md-6" style="text-align:right;">
						<img src="../assets/img/sp4.png"/>
					</div>
				</div>	
				<div class="row">
					<div class="col-md-6">
						<img src="../assets/img/sp5.png"/>
					</div>
					<div class="col-md-6">
						<div class="textL">
							<h4>数据防泄漏</h4>
							<b>企业痛点：</b>
							<p>公司文件数据泄露</p>
								<p>数据库访问安全问题</p>
								<p>公司内部数据安全问题</p>
								<b>数据防泄漏服务：</b>
								<p>禁止员工将文件发送出去，比如邮件、聊天、云盘等；记录员工的邮件/微信/QQ/钉钉聊天内容，追溯企业泄密源头</p>
								<p>禁止U盘拷贝电脑文件，并记录员工U盘的所有操作行为</p>
								<p>禁止共享公司网络，防止公司内网开放记录员工访问网站、微博论坛发送的内容等，发现企业泄密风险</p>
								<p>可对泄密事件进行分类审计、对比分析。并对趋势进行统计分析
							</p>
						</div>
					</div>
				</div>
	
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:'Service'
}
</script>

<style lang="scss">
#product{
	.carousel-caption{
		p{
			width:50%;
		}
	}
	.main{
		padding-top:70px;
		.mainBox{
			.row{
				margin-bottom: 70px;
			}
			.textL{
				// padding-left: 30px;
			}
			.textR{
				// padding-right: 30px;
			}
			h4{
				font-size: 26px;
				margin-bottom: 20px;
				margin-top: 0;
			}
			
			img{
				width: 90%;
				margin-top: 20px;
			}
		}
	}
	&.service{
		.mainBox{
			h4{
				margin-bottom: 15px;
				margin-top:0!important;
			}
			b{
				background-color: $--bg-primary;
		    border-radius: 3px;
		    color: #ffffff;
		    padding: 2px 0 4px 5px;
		    font-size: 14px;
		    line-height: 35px;
			}
			p{
				font-size: 14px;
				color: #666;
				line-height: 30px;
				margin:0;
				position: relative;
				padding-left: 20px;
				&:before{
					display: inline-block;
					content: '';
					position: absolute;
					top: 13px;
					left: 0;
					width: 8px;
					height: 2px;
					background-color: $--bg-primary;
				}
				i{
					font-size: 36px;
					margin-right: 10px;
					color: $--bg-primary;
					margin-top: 10px;
				}
			}
		}
	}
}
</style>